import { useState, useEffect } from 'react'
import CoiffeurService from 'service/CoiffeurService'

export default function useGetSalonLocationList() {
  const [data, updateData] = useState<any[]>()
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState(false)

  function fetchData() {
    setIsLoading(true)
    CoiffeurService.getCoiffeurSalonLocations()
      .then((r) => updateData(r.data))
      .catch((err) => setError(true))
      .finally(() => setIsLoading(false))
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => fetchData(), [])

  return { data, isLoading, error }
}
